import React from 'react';
import { storyblokEditable, StoryblokComponent } from 'gatsby-source-storyblok';
import { render, MARK_LINK } from 'storyblok-rich-text-react-renderer';
import { bgColors } from '../../assets/colors';
import { LinkWrapper } from '../../utils/link';

const Text = ({
  blok,
  destination,
  season,
  hotel,
  price,
  priceType,
  isNested = false,
}) => {
  // Applying installed Storyblok Rich Text Renderer for React to render the Rich text and embedded components
  // (https://github.com/claus/storyblok-rich-text-react-renderer)

  const RichText = ({ document }) => {
    return render(document, {
      defaultBlokResolver: (name, props) => {
        const blok = { ...props, component: name };
        return (
          <StoryblokComponent
            blok={blok}
            key={blok._uid}
            destination={destination}
            season={season}
            hotel={hotel}
            price={price}
            priceType={priceType}
            inTextBlock={true}
            parentColor={blok.background_color}
          />
        );
      },
      markResolvers: {
        [MARK_LINK]: (children, props) => {
          return <LinkWrapper link={props}>{children}</LinkWrapper>;
        },
      },
    });
  };

  // TailwindCSS utility classes --- --- --- --- --->
  const backgroundColors = bgColors;

  const padding = isNested
    ? 'my-2 md:my-4 px-4 md:px-4 py-2 md:py-4 is-nested'
    : 'px-4 md:px-8 py-2 md:py-4';

  const widths = {
    'w-full': 'w-full col-span-12',
    'w-3/4': 'w-full col-span-12 md:col-span-9',
    'w-2/3': 'w-full col-span-12 md:col-span-8',
    'w-1/2': 'col-span-12 md:col-span-6',
    'w-1/3': 'col-span-12 md:col-span-4',
    'w-1/4': 'w-full sm:w-1/2 md:w-1/3 lg:w-1/4 col-span-6 sm:col-span-3',
    auto: 'w-fit sm:max-w-prose',
  };

  const backgroundColor =
    backgroundColors[blok.background_color] || 'bg-white/90';

  // >--- --- --- --- --- TailwindCSS utility classes

  return (
    <div
      className={`${padding} rounded ${
        widths[blok.width]
      } ${backgroundColor} text-box`}
      {...storyblokEditable(blok)}
    >
      {RichText({ document: blok.text })}
    </div>
  );
};

export default Text;
